document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'hellofiber_subscription',
        'id': 'STORAGE_IDENTIFIER'
    });
});
